// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-nigeria/form-item-nigeria-pension-feedback/form-item-nigeria-pension-feedback.component.scss
// module id = 640
// module chunks = 0